import {UserManagerSettings} from "oidc-client-ts";

export interface OidcConfig {
	authority: string;
	clientId: string;
}

export function getOidcConfig(hostname: string = location.hostname): OidcConfig {
	switch (hostname) {
		case "localhost":
		case "127.0.0.1":
			// Local dev / dev-mode e2e authenticate against the Keycloak testcontainer the backend starts on
			// port 52080 (see KeycloakTestContainerInitializer + e2e/keycloak/realm-variocube.json), not cloud auth-test.
			return {
				authority: "http://localhost:52080/realms/variocube",
				clientId: "safecube-booking-local",
			};
		case "booking-dev.safecube.io":
			return {
				authority: "https://auth-test.variocube.com/realms/variocube",
				clientId: "safecube-booking-dev",
			};
		default:
			return {
				authority: "https://auth.variocube.com/realms/variocube",
				clientId: "safecube-booking",
			};
	}
}

export function toUserManagerSettings(
	config: OidcConfig,
	origin: string = location.origin,
): UserManagerSettings {
	return {
		authority: config.authority,
		client_id: config.clientId,
		redirect_uri: `${origin}/auth-callback`,
		post_logout_redirect_uri: `${origin}/`,
		scope: "openid email profile",
		automaticSilentRenew: true,
		response_type: "code",
	};
}
